import { portalScreenContext } from '../../../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../../../app/telemetry/usePortalTelemetry';
import { Box, Grid, Paper, Typography } from "@mui/material";
import { RecordStatusHistory } from "./RecordStatusHistory";
import { SupportingDocuments } from "./SupportingDocuments";
import { ViewCpdRecord } from "./ViewCpdRecord";
import { AddSupportingDocument } from "./AddSupportingDocument";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getCpdDetailsAsync } from "../../../../app/slices/creditsSlice";
import { useAppDispatch, useAppSelector } from "../../../../app/store/configureStore";
import { CpdCategory } from "../../../../app/models/staticData/cpdCategory";
import { CpdCategoryEnum } from "../../../../app/enums/cpdCategoryEnum";

export default function ViewCpdDetails() {

    const { creditRecordId } = useParams<{ creditRecordId: string }>();

    const dispatch = useAppDispatch();

    const { cpdCategories } = useAppSelector(state => state.ReferenceData);
    const { cpdDetails } = useAppSelector(state => state.credits);
    const [cpdCategory, setCpdCategory] = useState<CpdCategory>();

    useEffect(() => {
        if (creditRecordId !== "") {
            dispatch(getCpdDetailsAsync(creditRecordId));
        }
    }, [creditRecordId, dispatch]);

    useEffect(() => {
        if (cpdDetails !== null && cpdCategories && cpdCategories.length > 0) {
            setCpdCategory(cpdCategories.find(x => x.id === cpdDetails.cpdCategoryId));
        }
    }, [cpdDetails, cpdCategories]);

    usePortalScreen(portalScreenContext('ViewCpdDetails'), undefined, true);

    return <Box sx={{ width: '100%' }} component={Paper}>
        <Grid container rowSpacing={4} sx={{ p: '2%' }}>
            <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
                <ViewCpdRecord />
            </Grid>

            <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
                <Typography variant='h5' sx={{ mb: 2 }}>Supporting documents</Typography>
                <SupportingDocuments />
            </Grid>

            {cpdCategory && cpdCategory.filesEditable &&
                cpdCategories?.find(x => x.id === cpdDetails?.cpdCategoryId)?.code !== CpdCategoryEnum.AnnualPlan &&
                <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
                    <Typography variant='h5' sx={{ mb: 2 }}>Add supporting document</Typography>
                    <AddSupportingDocument />
                </Grid>}

            <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
                <Typography variant='h5' sx={{ mb: 2 }}>Status history</Typography>
                <RecordStatusHistory />
            </Grid>
        </Grid>
    </Box>
}
